<template>
  <div
    class="relative h-20 min-w-[120px]"
    :class="{ '!h-12': !hasErrors}"
  >
    <div
      v-if="icon"
      class="ml-3 absolute h-12 flex place-items-center place-content-center"
    >
      <img
        :src="icon"
        class="h-5 w-5"
      >
    </div>
    <button
      id="dropzone"
      :class="{'pl-11': icon}"
      class="ring-1 ring-[#CFCFCF] rounded h-12 px-5 w-full font-source-sans-pro focus:outline-none focus-within:bg-[#e8f0fe] hover:ring-gray group-hover:bg-[#e8f0fe] group-disabled:bg-semigray disabled:bg-semigray
        flex justify-start items-center group cursor-default"
      type="button"
      @dragover.prevent
      @drop="onDrop($event)"
    >
      <p
        v-if="innerValue.length == 0"
        class="text-semigray"
      >
        {{ placeholder }}
      </p>
      <div
        v-for="(item, index) in showableItems()"
        :id="item.value"
        :key="index"
        :draggable="draggable"
        class="inline-block mr-2 rounded-3xl bg-gray-lightest py-1 px-2 hover:bg-gray-light"
        :class="{'cursor-move': draggable }"
        @dragstart="dragStart($event, item)"
      >
        {{ item }} 
        <span
          class="ml-1 hover:text-red cursor-pointer"
          @click.stop="removeItem(item)"
        >
          <i
            slot="prefix"
            class="fas fa-times"
          />
        </span>
      </div>
      <div
        v-if="!showAll && showableItems().length < innerValue.length"
        class="inline-block mr-2 rounded-3xl bg-gray-lightest py-1 px-2 hover:bg-gray-light"
      >
        + {{ (innerValue.length - showableItems().length) }}
      </div>
    </button>
    <div
      v-if="hasErrors"
      :class="{ '!h-[32px]': validationErrors }"
      class="font-source-sans-pro text-sm text-red transition-all h-[0px] duration-1000"
    >
      {{ validationErrors ? validationErrors[0] : "" }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      default: null,
      validator: value =>
        typeof value === "string" ||
        value === null ||
        Array.isArray(value) ||
        typeof value === "number"
    },
    placeholder: {
      type: String,
      default: ""
    },
    validationErrors: {
      type: Array,
      default: () => {
        return [];
      }
    },
    icon: {
      type: String,
      default: ""
    },
    draggable: {
      type: Boolean,
      default: false
    },
    showAll: {
      type: Boolean,
      default: false
    },
    hasErrors: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      innerValue: [],
    };
  },
  watch: {
    value: {
      handler() {
        this.innerValue = this.value
      },
      deep: true
    }
  },
  beforeMount() {
    this.innerValue = this.value
  },
  methods: {
    showableItems() {
      if(this.showAll){
        return this.innerValue
      }
      return this.innerValue.slice(0, 2);
    },
    dragStart(event, value) {
      event.dataTransfer.setData("value", value);
    },
    onDrop(event) {
      const id = event.dataTransfer.getData("value");

      const atElement = document.elementFromPoint(event.clientX, event.clientY);
      const atId = atElement.id;

      const indexInsertBefore = this.innerValue.findIndex(item => {
        // eslint-disable-next-line
        return item.value == atId;
      });
      const indexToSplice = this.innerValue.findIndex(item => {
        // eslint-disable-next-line
        return item.value == id;
      });

      if (indexInsertBefore !== -1 && indexToSplice !== -1) {
        const itemToInsert = this.innerValue.splice(indexToSplice, 1);
        this.innerValue.splice(indexInsertBefore, 0, itemToInsert[0]);
      }

      event.dataTransfer.clearData();

      this.emitInput();
    },
    removeItem(value) {
      const removeIndex = this.innerValue.findIndex(item => {
        return item === value;
      });

      if (removeIndex !== -1) {
        this.innerValue.splice(removeIndex, 1);
      }

      this.$emit("input", this.innerValue);
    },
    emitInput() {
      let input = null;
      if (this.multiple) {
        input = this.innerValue.map(item => {
          return item.value;
        });
      } else {
        input = this.innerValue[0] ? this.innerValue[0].value : null;
      }
      this.$emit("input", input);
    }
  }
};
</script>
